import { useState } from "react";
import { Accordion, Card, Col, Row, useAccordionButton } from "react-bootstrap";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { ButtonFavorite } from "../../../../../components/button-favorite";
import { FlatCardObject } from "../../../../../components/flat-card-object";
import { IMaterial } from "../../../../../models/IMaterial";
import { IObjectResponse } from "../../../../../models/IObjectResponse";
import { Objects } from "../../../home/styles";
import { CardButton, CardUnity } from "./styles";
import { removeFavorite } from "../../../../../services/favorites.service";
import { toast } from "react-toastify";

function CustomToggle({ children, eventKey, activeEventKey }: any) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
        activeEventKey(eventKey);
    });

    return (
        <div onClick={decoratedOnClick}>
            {children}
        </div>
    );
}

export function UnityAccordion(props: any) {
    const [activeKey, setActiveKey] = useState<string>('')


    const handleActiveCurrentKey = (key: any) => {
        if (activeKey === key) {
            setActiveKey('');
        } else {
            setActiveKey(key);
        }
    }

    const handleRemoveFavorite = (id: number) => {
		removeFavorite(id)
			.then(() => {
				toast.success("Unidade removida com sucesso!", {
					position: "bottom-center",
				});
			})
			.catch((err: any) => {
				toast.error("Ocorreu um erro ao remover esta unidade.");
			});
	};

    return (
        <>
            <Accordion>
                {!!props.unities && props.unities.map(((unity: IMaterial, index: string) => {
                    return (
                        <Card className="mb-3" key={unity.id} id={String(unity.id)}>
                            <CustomToggle eventKey={String(unity.id)} activeEventKey={handleActiveCurrentKey}>
                                <CardUnity>
                                    <Row>
                                        <Col>{activeKey === String(unity.id) ? (<AiFillCaretDown></AiFillCaretDown>) : (<AiFillCaretRight></AiFillCaretRight>)} {unity.title}</Col>
                                        <Col>
                                            <CardButton>
                                                <ButtonFavorite material={unity} isMaterialView={false} removeFavorite={handleRemoveFavorite} variant="blueberry" />
                                            </CardButton>
                                        </Col>
                                    </Row>
                                </CardUnity>
                            </CustomToggle>
                            <Accordion.Collapse eventKey={String(unity.id)}>
                                <Card.Body>
                                    <Objects>
                                        {!!unity?.medias && unity?.medias.map((arrayMedias: IObjectResponse) => {
                                            return (

                                                <div key={arrayMedias.id}>
                                                    <FlatCardObject detailsMode object={arrayMedias} />
                                                </div>
                                            )
                                        })}
                                        {unity.medias?.length === 0 ? (
                                            <h6>Nenhum arquivo na unidade.</h6>
                                        ) : (
                                            <></>
                                        )}
                                    </Objects>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    )
                }))}



            </Accordion>
        </>
    )
}
